import { RegisterModule } from '@/typings/common'
import {
  LKFormdataState,
  LKFormdataGetters,
  LKFormdataMutations,
  LKFormdataActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: LKFormdataState,
    getters: LKFormdataGetters,
    mutations: LKFormdataMutations,
    actions: LKFormdataActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as LKFormdataStoreModule,
  mapper as lkFormdataMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
